import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";
import icon from '../../../images/icon/magic-black.svg'
import icon1 from '../../../images/feature/img02.png'
import icon2 from '../../../images/feature/img01.png'

const FeatureSection = (props) => {

    const [activeIndex, setActiveIndex] = useState(0);

    const toggleAccordion = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    const accordionData = [
        {
            title: "Send Money Instantly",
            content:
                "Enjoy fast, real-time money transfers to family, friends, or business partners anywhere in the world with instant processing and minimal delays.",
        },
        {
            title: "Zero Transfer Fees",
            content:
                "Benefit from competitive exchange rates and low service charges, making your international remittances more affordable.",
        },
        {
            title: "Secure Transactions",
            content:
                "Your money is protected with industry-leading security measures and encrypted transfer systems ensuring safe and reliable transactions.",
        },
        {
            title: "Track Transfers in Real-Time",
            content:
                "Stay updated with live tracking of your transactions and instant notifications on transfer status at every step.",
        },
    ];

    return (
        <section className="feature pb-100 pt-100">
            <div className="container">
                <div className="feature-wrap">
                    <div className="row align-items-center mt-none-30">
                        <div className="col-lg-6 mt-30">
                            <div className="feature-left-item pos-rel">
                                <div className="xb-img"><img src={icon1} alt="" /></div>
                                {/* <div className="xb-img-two"><img className="updown-2" src={icon2} alt="" /></div> */}
                            </div>
                        </div>
                        <div className="col-lg-6 mt-30">
                            <div className="feature-right-item mt-30">
                                <div className="sec-title--two sec-title--four mb-40">
                                    <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                                        <div>
                                            <div className="sub-title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms"><img src={icon} alt="" />Key Features</div>
                                        </div>
                                    </Fade>
                                    <Fade direction='down' triggerOnce={'false'} duration={1500} delay={9}>
                                        <div>
                                            <h2 className="title mb-15 wow skewIn" data-wow-duration="600ms">Your Trusted Money Transfer Solution</h2>
                                        </div>
                                    </Fade>
                                    <p>Experience fast, affordable, and secure money transfers across the globe. We ensure your funds reach the right hands quickly and safely.</p>
                                </div>
                                <div className="xb-faq xb-faq-two">
                                    <ul className="accordion_box clearfix list-unstyled">
                                        {accordionData.map((item, index) => (
                                            <li
                                                className={`accordion block ${activeIndex === index ? "active-block" : ""}`}
                                                key={index}
                                            >
                                                <div
                                                    className={`acc-btn ${activeIndex === index ? "active" : ""}`}
                                                    onClick={() => toggleAccordion(index)}
                                                >
                                                    {item.title}
                                                    <span className="arrow"></span>
                                                </div>
                                                <div
                                                    className={`acc_body ${activeIndex === index ? "current" : ""}`}
                                                    style={{
                                                        display: activeIndex === index ? "block" : "none",
                                                    }}
                                                >
                                                    <div className="content">
                                                        <p>{item.content}</p>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FeatureSection;
